/* @flow */
import * as React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import Greeting from 'components/Greeting.jsx';
import Link from 'components/Link.jsx';
import Text from 'components/Text.jsx';
import UserAvatar from 'users/components/UserAvatar.jsx';
import UserNavigationMenu from 'components/UserNavigationMenu.jsx';

import './styles/AccountNavigation.scss';

type Props = {
  ...AccountNavigationQuery,
};

function AccountNavigation(props: Props) {
  const { user } = props;

  const canAddProfilePicture = CurrentUser.getUser().canAddProfilePicture();
  const name = user ? user.display_name : '_ _ _';

  return (
    <div className="AccountNavigation">
      {canAddProfilePicture && (
        <Link to="/settings/profile">
          <UserAvatar className="AccountNavigation-avatar" user={user} color="grey" size="large" />
        </Link>
      )}
      <div className="AccountNavigation-content">
        <Text color="thunder" size="xsmall">
          <Greeting />,
        </Text>
        <UserNavigationMenu showRCE={user ? user.is_rce : false}>
          <Link color="inherit" className="AccountNavigation-content-user">
            <Text truncate size="large">
              {name}
            </Text>
            <Glyph name="chevron-down" size="xsmall" />
          </Link>
        </UserNavigationMenu>
      </div>
    </div>
  );
}

const withUser = graphql(
  gql`
    query AccountNavigation {
      user: me {
        id
        uuid
        is_rce
        display_name
        initials
        profile_picture {
          urls {
            cdn
          }
        }
      }
    }
  `,
  {
    props: ({ data }) => data,
  }
);

export { AccountNavigation };
export default withUser(AccountNavigation);
